var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',{attrs:{"title":"Payouts","subtitle":_vm.$store.getters.periodSelected ? _vm.$store.getters.periodSelected.label : ''}},[_c('div',[_c('Payouts-Table')],1),_c('div',{attrs:{"slot":"corner"},slot:"corner"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }